// @ts-nocheck TODO: fix types for the entire file

import styled, { StyledComponent } from '@emotion/styled';
import { Divider, Link, LinkProps } from '@mui/material';
import { Typography } from 'components/Typography';
import { pxToEm, Theme } from 'theme';
import palette from '../../../theme/palette';

export const CategoryTitle = styled(Typography)`
  font-weight: 600;
  font-size: ${pxToEm(36)};
  line-height: ${pxToEm(17)};
`;

export const BrandsDivider = styled(Divider, {
  shouldForwardProp: (prop) => String(prop) !== 'isDesktopHidden',
})<{ isDesktopHidden?: boolean }>`
  margin: ${pxToEm(24)} 0;
  border-color: ${({ theme }: { theme: Theme }) => theme.palette.grey['200']};
  ${({ theme }: { theme: Theme }) => theme.breakpoints.up('md')} {
    margin: ${({ isDesktopHidden }: { isDesktopHidden: boolean }) =>
      isDesktopHidden ? '40px 0 0' : `${pxToEm(40)} 0`};
    ${({ isDesktopHidden }: { isDesktopHidden: boolean }) =>
      isDesktopHidden && 'border: 0'};
  }
`;

export const CategoryTitleLink: StyledComponent<LinkProps> = styled(Link)`
  margin-right: auto;
  padding: 0;
  margin-bottom: 24px;
  display: block;
`;

export const Label = styled.span<{ bgColor?: string }>`
  cursor: default !important;
  padding: ${pxToEm(6)} ${pxToEm(12)};
  position: relative;
  line-height: ${pxToEm(16)};
  font-size: ${pxToEm(12)};
  background-color: ${({ bgColor }: { bgColor: string }) =>
    bgColor ?? palette.lime.main};
  color: ${palette.primary.main};
  border-radius: 100px;
`;

export const BrandsColumns = styled.div`
  column-count: 5;
  column-gap: ${pxToEm(24)};
  margin-top: 0.5em;
  ${({ theme }: any) => theme.breakpoints.down('lg')} {
    column-count: 4;
  }
  ${({ theme }: any) => theme.breakpoints.down('md')} {
    column-count: 3;
  }
  ${({ theme }: any) => theme.breakpoints.down('sm')} {
    column-count: 2;
  }
  ${({ theme }: any) => theme.breakpoints.down(480)} {
    column-count: 1;
  }

  @supports (-webkit-hyphens: none) {
    .MuiBox-root {
      display: inline-block;
    }
  }
`;

export const BrandItem = styled.div`
  display: flex;
  align-items: flex-start;
  align-items: center;
  gap: 0.4rem;
`;

export const BrandLinkText = styled.span`
  display: inline-block;
`;

export const BrandLink = styled(Link, {
  shouldForwardProp: (prop) => String(prop) !== 'isAvailable',
})<{ isAvailable: boolean }>`
  color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
  cursor: ${({ isAvailable }: { isAvailable: boolean }) =>
    isAvailable ? 'pointer' : 'not-allowed'};
  line-height: 30px;
  &:hover {
    ${BrandLinkText} {
      text-decoration: underline;
    }
  }
  ${({ isAvailable }: { isAvailable: boolean }) =>
    !isAvailable
      ? `
    pointer-events: none;
    `
      : ''}
`;

export const LabelWrapper = styled.span`
  display: flex;
  align-items: center;
`;
